import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PaymentPage from './PaymentPage';
import { getData } from '../../../state/reducers/ApplicationReducer';
import {
  getError,
  getQuote,
  getPaymentRecord,
  isPaymentLinkSent,
} from '../../../state/reducers/PaymentReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';
import PaymentActions from '../../../state/actions/PaymentActions';
import { isLAO } from '../../../state/reducers/LoginReducer';

function mapStateToProps(state) {
  let data = getData(state);
  let { feeAmount } = getQuote(state) || {};
  let application = { ...data, feeAmount };
  const zeroPayment = state.application.zeroPayment || null;
  return {
    isLAO: isLAO(state),
    error: getError(state),
    quote: getQuote(state),
    paymentRecord: getPaymentRecord(state),
    application: application,
    isLinkSent: isPaymentLinkSent(state),
    isZeroPayment: zeroPayment,
  };
}

let { clearCurrentApplication, checkZeroPayment } = ApplicationActions;
let { clearPaymentLinkSent } = PaymentActions;

export default compose(
  connect(mapStateToProps, {
    reset: clearCurrentApplication,
    checkZeroPayment,
    clearPaymentLinkSent,
  })
)(PaymentPage);



// WEBPACK FOOTER //
// ./src/view/scenes/Payment/index.js